<script>
import BookRequestAcForm from '@components/book-request-ac-form'
import ErrorComponent from '@components/error-component'
import LOCALE from '@constants/locale'

// Dedicated view wrapping the book-request form (routed in router/routes.js).
export default {
  page: {
    title: 'Libro de Reclamaciones',
    meta: [{ name: 'description', content: 'Libro de Reclamaciones' }],
  },
  components: {
    BookRequestAcForm,
    ErrorComponent,
  },
  data() {
    return { loading: true, error: false }
  },
  computed: {
    // Required deep-link query; anything missing/invalid sends the user to 404.
    hasValidParams() {
      const { country_code: countryCode, language, token, isguest } = this.$route.query
      return (
        typeof countryCode === 'string' &&
        LOCALE.COUNTRY_CODES_BOOK_REQUEST.includes(countryCode.toUpperCase()) &&
        typeof language === 'string' &&
        LOCALE.LANGUAGES.some(l => language.toLowerCase().startsWith(l)) &&
        typeof token === 'string' &&
        token.length > 100 &&
        (isguest === 'true' || isguest === 'false' || isguest === undefined)
      )
    },
  },
  created() {
    if (!this.hasValidParams) this.$router.replace({ name: '404' })
  },
  errorCaptured() {
    this.error = true
    return false
  },
  methods: {
    onSubmitted() {
      // push (not replace) so the browser back button returns to the form.
      this.$router.push({
        name: 'book-request-ac-success',
        query: {
          language: this.$route.query.language,
          country_code: this.$route.query.country_code,
        },
      })
    },
  },
}
</script>

<template>
  <div
    v-if="hasValidParams"
    :class="$style.container">
    <ErrorComponent
      v-if="error"
      :class="$style.error"
      :text="$t('COMMON.ERROR_MESSAGE')" />
    <template v-else>
      <BookRequestAcForm
        @ready="loading = false"
        @error="error = true"
        @submitted="onSubmitted" />
      <div
        v-if="loading"
        :class="$style.loading">
        <v-progress-circular
          :width="3"
          :class="$style.progress"
          ss-circular
          indeterminate
        />
      </div>
    </template>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.container {
  display: flex;
  width: 100%;
  max-width: $size-content-width-max;
  min-height: 100vh;
  margin: 0 auto;

  // Mobile-app feel (this view is opened in a webview), like the main Layout.
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.error {
  align-self: flex-start;
  width: 100%;
  padding-top: 10rem; // match article-builder's top placement
}

.loading {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding-top: 10rem; // match article-builder's top placement
  text-align: center;
  background: $color-body-bg;
}

.progress {
  color: $rappi-green;
}
</style>
